import { GetterTree } from "vuex";
import { RootState } from "../types";
import { InfoCandidate } from "./types";
export const getters: GetterTree<InfoCandidate, RootState> = {
  candidateInfo(state) {
    return state.data;
  },
};
